import { Link, Outlet } from "react-router-dom";
import {ChartPieIcon, MenuIcon, UserCircleIcon, UserGroupIcon } from '@heroicons/react/solid';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from './../Features/auth/authSlice';
import SideNavOptionHelper from "./SideNavOptionHelper";
import { useState } from "react";
import Logo from "../Views/Logo";
import { useLogoutMutation } from "../Features/usersSlice";
import { logOut } from "../Features/auth/authSlice";
import { useDispatch } from "react-redux";
import swal from 'sweetalert';
import { AdjustmentsIcon, ChevronDownIcon, ChevronUpIcon, CogIcon, QuestionMarkCircleIcon } from "@heroicons/react/outline";

function UserLayout() {
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(true)
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openNavOption, setOpenNavOption] = useState(0);
  const [logout, {isLoading}] = useLogoutMutation();

  const  user  = useSelector(selectCurrentUser);

    // close on click outside
    // useEffect(() => {
    //   const clickHandler = ({ target }: MouseEvent) => {
    //     if (!sidebar.current || !trigger.current) return;
    //     if (
    //       !sidebarOpen ||
    //       sidebar.current.contains(target) ||
    //       trigger.current.contains(target)
    //     )
    //       return;
    //     setSidebarOpen(false);
    //   };
    //   document.addEventListener('click', clickHandler);
    //   return () => document.removeEventListener('click', clickHandler);
    // });

  const logUserOut = async () =>{
    try {
      const resp = await logout().unwrap()
      dispatch(logOut())
  } catch (err) {
      if(err){
          swal("Error", err.message,"error")
          dispatch(logOut())
      }    
    }
  }

  const trancateText = (str)=>{
    return str.length > 22 ? str.substring(0, 22) + "..." : str;
  }

  const toggleBtn = document.getElementById('toggleBtn');

  const toggleNav = ()=>{
    toggleBtn.classList.toggle('hidden')
  }
  return (
    <div className="w-full fixed">
      {/* Header and Feed */}
        {/* Feed Header */}
        {/* <div class="flex"> */}
          <div className="flex justify-between shadow-2xl items-center p-1 bg-teal-600 border-b">
            <div className="flex items-center md:flex-1">
              <div
                // onClick={() => toggleNav()}
                className="mr-2 text-gray-100 flex flex-shrink-0 items-center w-8 h-8 rounded-sm" 
                 value="Close sidebar" >
                <MenuIcon className="h-6 w-12" />
              </div>
            </div>
            <div className="">
              <Logo />
            </div>
          </div>
          {/* Feed */}
          <main className="flex">
              {/* stick right side nav */}
              <aside id="toggleBtn" className={`h-screen bg-white shadow-r-2xl sticky top-0 overflow-scroll w-60`}>
                <div className="flex flex-col mb-20">
                  <div className="flex flex-col text-sm rounded-sm group">
                    <div className="flex items-center justify-between p-2 bg-white">
                      <div className="flex items-center">
                        <UserCircleIcon className={`h-10 w-8 mr-4 text-gray-500`} />
                        <div className="text-gray-700 text-sm text-sm">
                          <div className="text-gray-700 font-bold">{trancateText('pambi sichone')}</div>
                          <div className="text-gray-500 text-xs">{trancateText('pambisichone@gmail.com')}</div>
                        </div>
                      </div>
                        <div onClick={() => {setDropdownOpen(!dropdownOpen)}} className="relative">
                          
                          {
                            (dropdownOpen)?
                            <ChevronUpIcon 
                            className="h-4 w-4 text-gray-500"
                            />
                            :
                            <ChevronDownIcon 
                            className="h-4 w-4 text-gray-500"
                            />
                          }
                          {dropdownOpen && (
                            <div
                              className={`absolute -right-10 mt-2.5 flex h-90 w-32 flex-col rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark sm:right-0`}
                            >
                              <Link to={`/user/user-profile/${user.id}`} className="px-4.5 py-3 border border-gray-200 border-b-1 hover:bg-gray-100">
                                <h5 className="text-sm font-medium text-gray-700 pl-2">Acocount</h5>
                              </Link>
                              <div onClick={logUserOut} className="px-4.5 py-3 hover:bg-gray-100 cursor-pointer">
                                <h5 className="text-sm font-medium text-gray-700 pl-2">Log out</h5>
                              </div>
                            </div>
                          )}
                          {/* <!-- Dropdown End --> */}
                        </div>
                    </div>
                  </div>
                  <div onClick={()=>setOpenNavOption(1)} className={`flex flex-col`}>
                      <SideNavOptionHelper data={{title:[['Sales summury'],['Sales by route'],['Sales by employe'],['Sales by payment type'],['Receipts'],['Discounts'],['Taxes'],['Shifts']]}} Icon={ChartPieIcon} toggleHidden={(openNavOption)? '' : 'hidden'} IconColor={'text-green-400'} bgColor={'bg-gray-100'} lable="Reports" />
                  </div>
                  <div className={`flex flex-col`}>
                      <SideNavOptionHelper data={{title:[['Routes','/user/routes'],['All stations','/user/stations'], ['Regions','/user/manage-regions'], ['Seats','/user/manage-seats'], ['Time','/user/manage-time']]}} Icon={AdjustmentsIcon} IconColor={'text-rose-400'} lable="Routes" />
                  </div>
                  <div className={`flex flex-col`}>
                      <SideNavOptionHelper data={{title:[['All users','/user/users'],['Access rights','/user/access-rights']]}} Icon={UserGroupIcon} IconColor={'text-indigo-400'} lable="Users" />
                  </div>
                  <div className={`flex flex-col`}>
                      <SideNavOptionHelper data={{title:[['Purpose of travel','/user/purpose-of-travel-management']]}} Icon={CogIcon} IconColor={'text-gray-600'} lable="Settings" />
                  </div>
                  <div className={`flex flex-col`}>
                      <SideNavOptionHelper Icon={QuestionMarkCircleIcon} IconColor={'text-blue-500'} lable="Help" />
                  </div>
                </div>
              </aside>
              {/* Main feed*/}
            <div className="h-screen z-0 overflow-y-scroll md:p-4 flex flex-1 flex-col mb-20">
              <Outlet />
            </div>
          </main>
        {/* </div> */}
    </div>
  );
}

export default UserLayout;
